import React from 'react';
import EditorBullet from '@wix/da-ds/pkg/Icons/24x24/EditorBullet';
import EditorOrdered from '@wix/da-ds/pkg/Icons/24x24/EditorOrdered';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../menus/_partials/EditorIconButtonWithContextMenu';
import { isExtensionInstalled } from '../../utils/tiptap';
const List = ({ editor })=>{
    const { t } = useTranslation('editor');
    if (!isExtensionInstalled(editor, 'orderedList') || !isExtensionInstalled(editor, 'bulletList')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "format:list",
        tooltipText: t('ext.deviation.toolbar.alignment'),
        "aria-label": t('ext.deviation.toolbar.alignment'),
        icon: EditorBullet,
        items: [
            {
                featureId: 'format:bulletList',
                label: t('button.list.bulletList'),
                IconComponent: EditorBullet,
                isActive: editor.isActive('bulletList'),
                onClick: ()=>editor.chain().focus().toggleBulletList().run()
            },
            {
                featureId: 'format:numberList',
                label: t('button.list.numberedList'),
                IconComponent: EditorOrdered,
                isActive: editor.isActive('orderedList'),
                onClick: ()=>editor.chain().focus().toggleOrderedList().run()
            }
        ]
    });
};
List.displayName = 'List';
export default List;

//# sourceMappingURL=List.js.map